// extracted by mini-css-extract-plugin
export default {"show_title":"LiveItem_show_title__t76MW"};